import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'nonprofit',
		path: '/nonprofit',
		component: loadable(async () => import(/* webpackChunkName: "pages/nonprofit" */ './index'), {
			exportName: 'Nonprofit',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
			config: {
				disallowUserData: true,
				cache: {
					enabled: true,
					lifetimeInSeconds: 30 * 60,
				},
			},
		},
	},
];
